import { styled } from '@mui/material/styles';
import { SmsIcon, WhatsAppIcon, EmailIcon, LiveChatIcon, MessengerIcon, InstagramIcon } from 'assets/images/channels';
import { DeleteIcon } from 'assets/images/icons';

const StyledSvgWrapper = styled('span')({
    '& svg path': {
        fill: '#1F4C5C',
    },
});

export const getChannelIcon = type => {
    switch (type) {
        case 0:
            return <SmsIcon />;
        case 1:
        case 7:
            return <WhatsAppIcon />;
        case 2:
            return <EmailIcon />;
        case 4:
            return <LiveChatIcon />;
        case 5:
            return <MessengerIcon />;
        case 6:
            return <InstagramIcon />;
        case null:
            return (
                <StyledSvgWrapper>
                    <DeleteIcon />
                </StyledSvgWrapper>
            );
        default:
            return null;
    }
};
